'use strict';

var _ = require('lodash');
var angular = require('angular');
var ClearDemandAdjustmentModalDirective = function ClearDemandAdjustmentModalDirective() {
  return {
    restrict: 'E',
    template: require('../templates/clear-demand-adjustment-modal.html'),
    controller: 'ClearDemandAdjustmentModalController',
    scope: {
      selectedCalendars: '='
    },
    link: function link(scope) {
      angular.element('.rm-clear-demand-adjustments-modal .modal.rm-modal').on('hidden.bs.modal', function () {
        scope.resetModal();
      });
    }
  };
};
ClearDemandAdjustmentModalDirective.$inject = [];
module.exports = ClearDemandAdjustmentModalDirective;